import React from 'react'

export const EMAIL = 'EMAIL'
export const PHONE = 'PHONE'
export const TEXT = 'TEXT'